export default {
	mainMenu: {
		join: 'Start',
		create: 'Start',
		admin: 'Admin',
		language: 'Sprog'
	},
	login: {
		username: 'Brugernavn',
		password: 'Kodeord',
		login: 'Log På',
		failed: 'Login mislykkedes'
	},
	room: {
		connecting: 'Tilslutter',
		loading: 'Indlæser',
		roomCode: 'Kode',
		join: 'Tilslut',
		codeError: 'Forkert kode',
		serverError: 'Ingen forbindelse til serveren',
		connectionError: 'Kunne ikke forbinde',
		lobby: 'Lobby',
		waiting: 'Venter',
		pageType: 'Spiltype',
		unset: 'Uspecificeret',
		dilemma: 'Stem & Diskutér',
		roleplay: 'Roller & Spil',
		typeChangeWarning: 'Ændring fra \'Rollespil\' vil sende spillere tilbage til lobbyen. Vil du fortsætte?',
		count: 'Antal spillere logget ind:'
	},
	master: {
		selectTheme: 'Vælg et tema',
	},
	game: {
		answers: 'Reaktioner modtaget',
		chooseAnswer: 'Vælg et korrekt svar',
		showAnswers: 'Her er jeres svar',
		sendMessage: 'Send Besked',
		studentWaiting: 'Kig på facilitatorens skærm'
	},
	roleplay: {
		defaultNextMessage: 'Tryk næste når du er klar'
	},
	misc: {
		back: 'Tilbage',
		cancel: 'Fortryd',
		quit: 'Afslut',
		start: 'Start',
		next: 'Næste',
		finish: 'Afslut',
		continue: 'Fortsæt',
		select: 'Vælg',
		fullScreen: 'Fuld skærm'
	}
}